import React, { useState } from 'react';

import createUseContext from 'constate';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const useSnackbar = () => {
  const [message, setMessage] = useState(undefined);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);

  const showSnakbar = (msg) => {
    setMessage(msg);
    setIsSnackbarOpen(true);
  };

  return {
    isSnackbarOpen,
    setIsSnackbarOpen,
    showSnakbar,
    message,
    snackbar: (
      <Snackbar
        open={isSnackbarOpen}
        autoHideDuration={1500}
        onClose={() => {
          setIsSnackbarOpen(false);
        }}
      >
        <Alert
          variant="filled"
          onClose={() => {
            setIsSnackbarOpen(false);
          }}
          severity="success"
        >
          {message}
        </Alert>
      </Snackbar>
    ),
  };
};

const [SnackbarProvider, useSnackbarContext] = createUseContext(useSnackbar);

export {
  SnackbarProvider,
  useSnackbarContext,
};
